export const READING_MODE_ON = 'OD/READING_MODE_ON'
export const READING_MODE_OFF = 'OD/READING_MODE_OFF'


export interface ReadingModeOnAction {
  readonly type: typeof READING_MODE_ON;
}

export interface ReadingModeOffAction {
  readonly type: typeof READING_MODE_OFF;
}

